import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import routes from '@/routes'

import { Board } from '@/pages/Board'
import { DemandsDetails } from '@/pages/DemandDatails'
import { BoardSettings } from '@/pages/Board/BoardSettings'
import { QAReports } from '@/pages/QAReports'
import { DemandReports } from '@/pages/DemandReports'

import { DashboardLayout } from '@/layouts'
import { Fallback } from './Fallback'
import { ProfileSettings } from '@/pages/ProfileSettings'

const Demands = lazy(() => import('@/pages/Demands'))

export default function Private() {
  return (
    <Routes>
      <Route
        path={routes.demands}
        element={
          <DashboardLayout>
            <Suspense fallback={<Fallback />}>
              <Demands />
            </Suspense>
          </DashboardLayout>
        }
      />
      <Route
        path={routes.demand}
        element={
          <Suspense fallback={<Fallback />}>
            <DashboardLayout>
              <DemandsDetails />
            </DashboardLayout>
          </Suspense>
        }
      />
      <Route
        path={routes.qa}
        element={
          <Suspense fallback={<Fallback />}>
            <DashboardLayout>
              <QAReports />
            </DashboardLayout>
          </Suspense>
        }
      />
      <Route
        path={routes.frame}
        element={
          <DashboardLayout>
            <Suspense fallback={<Fallback />}>
              <Board />
            </Suspense>
          </DashboardLayout>
        }
      />
      <Route
        path={routes.boardSettings}
        element={
          <DashboardLayout>
            <Suspense fallback={<Fallback />}>
              <BoardSettings />
            </Suspense>
          </DashboardLayout>
        }
      />
      <Route
        path={routes.demandReports}
        element={
          <DashboardLayout>
            <Suspense fallback={<Fallback />}>
              <DemandReports />
            </Suspense>
          </DashboardLayout>
        }
      />
      <Route
        path={routes.profileSettings}
        element={
          <DashboardLayout>
            <Suspense fallback={<Fallback />}>
              <ProfileSettings />
            </Suspense>
          </DashboardLayout>
        }
      />
      <Route path="*" element={<Navigate to={routes.demands} replace />} />
    </Routes>
  )
}
